<template>
    <div class="wrap">
        <!--            新增内容域-->
      <div class="top-area flex">
        <div class="title">新建内容域</div>
        <el-button plain size="mini" @click="openCtctrlPanel('simpletext')">纯文本</el-button>
        <el-button plain size="mini" @click="openCtctrlPanel('richtext')">富文本</el-button>
        <!--            <div class="top-button" @click="openCtctrlPanel('simpletext')">纯文本</div>-->
        <!--            <div class="top-button" @click="openCtctrlPanel('richtext')">富文本</div>-->
        <!--<div class="top-button" @click="ceshi()">ceshi</div>-->
      </div>

<!--        <el-dropdown trigger="click" @command="openCtctrlPanel">-->
<!--                <span class="el-dropdown-link">-->
<!--                新建内容域<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--                </span>-->
<!--            <el-dropdown-menu slot="dropdown">-->
<!--                <el-dropdown-item command="simpletext">纯文本</el-dropdown-item>-->
<!--                <el-dropdown-item command="richtext">富文本</el-dropdown-item>-->
<!--            </el-dropdown-menu>-->
<!--        </el-dropdown>-->


<!--        <div class="flex" style="margin-bottom: 15px;">-->
<!--            <button class="button" type="button" @click="getContentControls('contentControlChildren');" value="生成">内容域导航</button>-->
            <!--            <button class="button" type="button" @click="dialogFormVisible4 = true">内容域提取</button>-->
<!--        </div>-->

        <!--            内容域导航-->
        <div>
<!--            <div class="tishi-text">内容域标题 - 标签 - id</div>-->
          <div class="tree-container">
            <div class="page-nocont" v-show="ctctrlChildren.length==0">
              <div class="nocont-inner">
                <div class="nocont-desc">此文档还没有内容域</div>
              </div>
            </div>
            <ul class="overflow">
              <li v-for="(ctctrl, i) in ctctrlChildren"
                  v-bind:key="i">
                <div class="ctctrl-node"
                     @mouseenter="onEnterCtcrlItem(i)"
                     @mouseleave="onLeaveCtcrlItem(i)"
                     @click="onClickCtctrlItem(i, ctctrl.Tag, ctctrl.id, ctctrl.Alias, ctctrl.type)"
                     v-bind:class="[{activeClick: i === currentClick}, {activeHover: i === currentHover}]">
                  <el-tooltip class=""
                              effect="light"
                              :content="ctctrl.Alias"
                              placement="right">
                    <div class="node-text"
                         v-bind:style="{marginLeft: ctctrl.level * 20 + 'px'}">{{ctctrl.Alias}}</div>
                  </el-tooltip>
                  <!--                            <div class="node-text"-->
                  <!--                                 v-bind:style="{marginLeft: ctctrl.level * 20 + 'px'}"-->
                  <!--                            >{{ctctrl.Alias}}</div>-->
                  <!--                        小圆点-->
                  <!--                            <el-dropdown trigger="click"-->
                  <!--                                         @command="openCirclePanel"-->
                  <!--                                         size="mini"-->
                  <!--                                         placement="bottom"-->
                  <!--                                         v-show="i === currentClick || i === currentHover"-->
                  <!--                            >-->
                  <!--                                <div class="el-icon-more"></div>-->
                  <!--                                <el-dropdown-menu>-->
                  <!--                                    <el-dropdown-item command="insertMenu">设置内容域内容</el-dropdown-item>-->
                  <!--                                    <el-dropdown-item command="resetMenu">设置内容域属性</el-dropdown-item>-->
                  <!--                                    <el-dropdown-item command="clearMenu">清除内容域内容</el-dropdown-item>-->
                  <!--                                </el-dropdown-menu>-->
                  <!--                            </el-dropdown>-->

                </div>
                <!--                    右键弹出框 在内容域中插入内容-->
                <!--                    <vue-context-menu :context-menu-data=contextMenuData-->
                <!--                                      @onRightClickMenu="onRightClickMenu"-->
                <!--                    ></vue-context-menu>-->
                <!--                        <el-button type="text" @click="setCtctrlProp(ctctrl)">设置内容域</el-button>-->
              </li>
            </ul>


          </div>

        </div>

        <div class="bottom-button-container flex-start">
            <el-button type="primary" size="mini" @click="openCtctrlPanel('insertContent')" v-bind:disabled="ctctrlChildren.length==0">插入内容</el-button>
            <el-button type="primary" size="mini" @click="openCtctrlPanel('extractContent')" v-bind:disabled="ctctrlChildren.length==0">提取内容</el-button>
<!--            <div class="bottom-button" @click="openCtctrlPanel('insertContent')">插入内容</div>-->
<!--            <div class="bottom-button" @click="openCtctrlPanel('extractContent')">提取内容</div>-->
        </div>

<!--        内容域设置模块-->
        <div class="bottom-setting">
            <div class="bottom-title" style="padding-left: 7px;">内容域外观</div>
            <div class="bottom-item flex">
                <div class="bottom-label">显示</div>
                <el-select v-bind:disabled="ctctrlChildren.length==0" class="bottom-select" v-model="reset.border" value="border" size="mini">
                    <el-option label="边框" value="边框"></el-option>
                    <el-option label="无" value="无" :disabled="true"></el-option>
                </el-select>
                <div class="bottom-label">边框颜色</div>
                <el-color-picker v-bind:disabled="ctctrlChildren.length==0" v-model="reset.color" color-format="rgb" size="small" @change='resetCtctrlContent'></el-color-picker>
            </div>
            <div class="flex">
                <div class="bottom-title">内容域内容保护</div>
                <el-checkbox-group v-model="reset.checkmode" @change="resetCtctrlContent" v-bind:disabled="ctctrlChildren.length==0">
                    <el-checkbox label="不可删除"></el-checkbox>
                    <el-checkbox label="只读"></el-checkbox>
                </el-checkbox-group>
            </div>
        </div>
        <!-- json模块 -->
        <!-- <div class="bottom-setting">
            <div class="extract-text-body">
                <el-button type="primary" size="mini" @click="dialogFormVisible7 = true" v-bind:disabled="ctctrlChildren.length==0">JSON回填</el-button>
            </div>
        </div> -->
        
<!--        协作者权限配置-->
        <div class="bottom-coauther" >
            <div class="flex">
                <div class="bottom-title">协作者权限配置</div>
                <el-radio-group v-model="partauthMode" v-bind:disabled="ctctrlChildren.length==0">
                    <el-radio class="bottom-radio" :label="'hide'">隐藏</el-radio>
                    <el-radio class="bottom-radio" :label="'view'">只读</el-radio>
                    <el-radio class="bottom-radio" :label="'edit'">编辑</el-radio>
                </el-radio-group>
            </div>
            <el-button v-bind:disabled="ctctrlChildren.length==0" type="primary" size="mini" @click="actionDistPartAuth" class="bottom-button">应用</el-button>
        </div>

        <!--            新建内容域弹出框-->
        <el-dialog
                :visible.sync="dialogFormVisible"
                :close-on-click-modal="false"
                v-dialogDrag:{dialogDrag}="dialog.dialogDrag"
                v-dialogChange:{dialogChange}="dialog.dialogChange"
                :width="formWidth"

        >
            <template slot="title">
                <div class="dialog-title">内容域设置</div>
            </template>
            <el-form :model="form"
                     :label-width="formLabelWidth"
                     label-position="left"
                     size="small"
                     resetFields
            >
                <el-form-item>
                    <template slot="label">
                        <div class="form-item-title">标题</div>
                    </template>
                    <el-input v-model="form.displayname" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <template slot="label">
                        <div class="form-item-title">标签</div>
                    </template>
                    <el-input v-model="form.name" autocomplete="off" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item class="form-margin-adjust">
                    <template slot="label">
                        <div class="form-item-title">外观</div>
                    </template>
                </el-form-item>

                <el-form :inline="true" :model="form">
                <el-form-item class="form-inline">
                    <template slot="label">
                        <div class="">显&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp示</div>
                    </template>
                    <el-select v-model="form.border" value="border" style="width: 80px" size="small">
                        <el-option label="边框" value="边框"></el-option>
                        <el-option label="无" value="无" :disabled="true"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-inline" label-width="70px">
                    <template slot="label">
                        <div class="">边框颜色</div>
                    </template>
                    <el-color-picker v-model="form.color" color-format="rgb" size="small"></el-color-picker>
                </el-form-item>
                <!--                    <input type="color" v-model="form.test"></input>-->
                </el-form>

                <el-form-item label-width="70px" class="form-margin-adjust">
                    <template slot="label">
                        <div class="form-item-title">内容保护</div>
                    </template>
                </el-form-item>
                <el-form-item style="margin-left: -50px">
                    <el-checkbox-group v-model="form.checkmode" size="mini">
                        <el-checkbox class="form-item-checkbox" label="不可删除"></el-checkbox>
                        <el-checkbox class="form-item-checkbox" label="只读"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item class="form-margin-adjust" style="margin-left: -50px; text-align: center">
                    <el-button type="primary" size="mini" @click="actionCreateCtctrl">确 定</el-button>
                    <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
                </el-form-item>
            </el-form>

<!--            <div slot="footer" class="dialog-footer">-->
<!--                <el-button type="primary" size="mini" @click="actionCreateCtctrl">确 定</el-button>-->
<!--                <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>-->
<!--            </div>-->
        </el-dialog>
        <!--            插入内容域内容弹出框（富文本）-->
        <el-dialog
                :visible.sync="dialogFormVisible2"
                :close-on-click-modal="false"
                v-dialogDrag:{dialogDrag}="dialog.dialogDrag"
                v-dialogChange:{dialogChange}="dialog.dialogChange"
                width="840px"
        >
            <template slot="title">
                <div class="dialog4-title">插入内容域内容</div>
            </template>
            <div class="extract-text" style="padding-top: 0;">{{`ID: ${currentId}`}}</div>
            <div class="extract-text">{{`标签: ${currentTag}`}}</div>
            <el-tabs v-model="activeName"
                     @tab-click="handleClick"
                     style="padding: 0 10px; height: 400px;"
            >
                <el-tab-pane label="文本" name="simpletext">
                    <el-alert
                            title="此操作会在内容域原有内容后插入文本"
                            type="info"
                            show-icon
                            :closable="false"
                    >
                    </el-alert>
                    <div class="insert-text">正确格式示例：</div>
                    <div class="insert-sample">{{sampleJsonText}}</div>
                    <el-input
                            type="textarea"
                            :rows="8"
                            placeholder="请输入json对象或字符串"
                            v-model="textarea1"
                            style="height: 219px"
                            @input="dealWithOk"
                    >
                    </el-input>
                </el-tab-pane>
                <el-tab-pane label="图片" name="image">
                    <el-alert
                            title="此操作会在内容域原有内容后插入图片"
                            type="info"
                            show-icon
                            :closable="false"
                    >
                    </el-alert>
                    <div class="insert-text">正确格式示例：</div>
                    <div class="insert-sample">{{sampleJsonImage}}</div>
                    <el-input
                            type="textarea"
                            :rows="8"
                            placeholder="请输入json对象或字符串"
                            v-model="textarea2"
                            style="height: 219px"
                            @input="dealWithOk"
                    >
                    </el-input>
                </el-tab-pane>
                <el-tab-pane label="表格" name="table">
                    <el-alert
                            title="此操作会在内容域原有内容后插入表格"
                            type="info"
                            show-icon
                            :closable="false"
                    >
                    </el-alert>
                    <div class="insert-text">正确格式示例：</div>
                    <div class="insert-sample">{{sampleJsonTable}}</div>
                    <el-input
                            type="textarea"
                            :rows="6"
                            placeholder="请输入json对象或字符串"
                            v-model="textarea3"
                            @input="dealWithOk"
                    >
                    </el-input>
                </el-tab-pane>
                <el-tab-pane label="表格+图片+文本" name="complex">
                    <el-alert
                            title="此操作演示了向内容域中插入表格，图片等多种元素"
                            type="info"
                            show-icon
                            :closable="false"
                    >
                    </el-alert>
                    <div class="insert-text">正确格式示例：</div>
                    <div class="insert-sample">{{sampleJsonMix}}</div>
                    <el-input
                            type="textarea"
                            :rows="6"
                            placeholder="请输入json对象或字符串"
                            v-model="textarea4"
                            @input="dealWithOk"
                    >
                    </el-input>
                </el-tab-pane>
            </el-tabs>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible2 = false" size="small" class="dialog-button">取 消</el-button>
                <el-button type="primary"
                           @click="setCtctrlContent"
                           size="small"
                           class="dialog-button"
                           :disabled="noOk"
                >确 定</el-button>
            </div>
        </el-dialog>
        <!--            插入内容域内容弹出框（纯文本）-->
        <el-dialog
                :visible.sync="dialogFormVisible3"
                :close-on-click-modal="false"
                v-dialogDrag:{dialogDrag}="dialog.dialogDrag"
                v-dialogChange:{dialogChange}="dialog.dialogChange"
                width="600px"
        >
            <template slot="title">
                <div class="dialog4-title">插入内容域内容</div>
            </template>
            <div class="extract-text" style="padding-top: 0;">{{`ID: ${currentId}`}}</div>
            <div class="extract-text">{{`标签: ${currentTag}`}}</div>
            <el-tabs v-model="activeName"
                     @tab-click="handleClick"
                     style="padding: 0 10px; height: 325px;"
            >
                <el-tab-pane label="文本" name="simpletext">
                    <el-alert
                            title="此操作会清除内容域原有内容"
                            type="info"
                            show-icon
                            :closable="false"
                            style="margin-bottom: 14px;"
                    >
                    </el-alert>
                    <el-input 
                            type="input"
                            :rows="9"
                            placeholder="请输入内容"
                            v-model="textarea5"
                            style="height: 219px"
                    >
                    </el-input>
                </el-tab-pane>
            </el-tabs>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible3 = false" size="small" class="dialog-button">取 消</el-button>
                <el-button type="primary"
                           @click="setCtctrlContent"
                           size="small"
                           class="dialog-button"
                           :disabled="!textarea5">确 定</el-button>
            </div>
        </el-dialog>
        <!--            内容域提取弹出框-->
        <el-dialog
                :visible.sync="dialogFormVisible4"
                :close-on-click-modal="false"
                v-dialogDrag:{dialogDrag}="dialog.dialogDrag"
                v-dialogChange:{dialogChange}="dialog.dialogChange"
                width="600px"
        >
            <template slot="title">
                <div class="dialog4-title">内容域提取</div>
            </template>
            <div class="extract-text" style="padding-top: 0;">{{`ID: ${currentId}`}}</div>
            <div class="extract-text">{{`标签: ${currentTag}`}}</div>
            <el-alert
                    title="提示信息"
                    type="info"
                    show-icon
                    :closable="false"
                    class="dialog-alert"
            >
            </el-alert>
            <div class="extract-area">{{form4.content}}</div>
<!--            <el-form :model="form4">-->
<!--                <el-form-item label="id" :label-width="formLabelWidth3">-->
<!--                    <el-input v-model="form4.id" autocomplete="off" placeholder="请输入内容域id"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="标签" :label-width="formLabelWidth4">-->
<!--                    <el-input v-model="form4.selectTag" autocomplete="off" placeholder="请输入内容域标签"></el-input>-->
<!--                </el-form-item>-->

<!--                <el-form-item label="提取内容" :label-width="formLabelWidth3">-->
<!--                    <el-input type="textarea" autosize :autosize="{ minRows: 2, maxRows: 10}" v-model="form4.content" autocomplete="off"></el-input>-->
<!--                </el-form-item>-->
<!--            </el-form>-->
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible4 = false" size="small" class="dialog-button">取消</el-button>
                <el-button type="primary" size="small" @click="dialogFormVisible4 = false" class="dialog-button">确定</el-button>
            </div>
        </el-dialog>
        <!-- json回填弹出框 -->
        <!-- <el-dialog
                :visible.sync="dialogFormVisible7"
                :close-on-click-modal="false"
                v-dialogDrag:{dialogDrag}="dialog.dialogDrag"
                v-dialogChange:{dialogChange}="dialog.dialogChange"
                width="600px"
        >
            <template slot="title">
                <div class="dialog4-title">需要回填JSON的内容</div>
            </template>
            <el-tabs>
                <el-tab-pane label="JSON文本">
                    <div>正确格式实例："{\"body\":[{\"p\":[{\"@style\":\"border:none\"},{\"order\":0},{\"span\":[{\"order\":0},{\"@value\":\"回填数据修改\",\"@style\":\"font-size:0.91em;color:#000000\"}]}]}]}"</div>
                    <el-alert
                            title="此操作会清除原有内容"
                            type="info"
                            show-icon
                            :closable="false"
                            style="margin-bottom: 14px;"
                    >
                    </el-alert>
                    <el-tabs>
                        <el-input 
                                type="input"
                                :rows="9"
                                placeholder="请输入内容"
                                v-model="textarea7"
                                style="height: 219px"
                        >
                        </el-input>
                    </el-tabs>
                </el-tab-pane>
            </el-tabs>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible7 = false" size="small" class="dialog-button">取 消</el-button>
                <el-button type="primary"
                           @click="setReJson"
                           size="small"
                           class="dialog-button"
                           :disabled="!textarea7">确 定</el-button>
            </div>
            <div>

            </div>

        </el-dialog> -->
    </div>
</template>

<script>
    export default {
        name: "ctctrl",
        props: ['docEditor', 'ctctrlTree', 'ctctrlContentAll', 'config'],
        data: function () {
            return {
                // baseUrl: 'http://192.168.200.107:5000/',
                baseUrl: config.baseUrl,
                // baseUrl: "http://" + window.document.location.host + '/',
                ctctrlTag: '',
                ctctrlChildren: [],
                currentClick: null,
                currentHover: null,
                currentId: null,
                currentTag: null,
                currentAlias: null,
                currentType: null,
                // 下拉框
                selectType: '',
                // 新建内容域弹出框
                dialogTableVisible: false,
                dialogFormVisible: false,
                form: {
                    displayname: '',
                    name: '102410241024',
                    border: '边框',
                    color: 'rgb(155, 155, 155)',
                    checkmode: [],
                    test: '',
                },
                formLabelWidth: '50px',
                formWidth: '334px',
                // 内容域插入内容弹出框(富文本）
                dialogTableVisible2: false,
                dialogFormVisible2: false,
                dialogFormVisible7:false,
                formLabelWidth2: '80px',
                activeName: 'simpletext',
                textarea1: '',
                textarea2: '',
                textarea3: '',
                textarea4: '',
                textarea7:'',
                // 内容域插入内容弹出框(纯文本）
                dialogTableVisible3: false,
                dialogFormVisible3: false,
                noOk: true,
                formLabelWidth3: '80px',
                textarea5: '',
                // 内容域提取弹出框
                dialogTableVisible4: false,
                dialogFormVisible4: false,
                form4: {
                    selectTag: '',
                    content: '',
                    id: '',
                },
                formLabelWidth4: '80px',
                // 弹出框拖拽拉伸设置
                dialog: {                   // dialog显示隐藏
                    dialogDrag: true,       // 可拖拽
                    dialogChange: false,    // 可拉伸
                },
                //
                reset: {
                    displayname: '',
                    name: '',
                    border: '边框',
                    color: 'rgb(155, 155, 155)',
                    checkmode: [],
                    test: '',
                },
                setContentId: -1,
                partauthMode: 'hide',
                sampleJsonText: `
                {
                    body:[
                        {"p":[
                            {"@style":"text-align:left;font-size:14px"},
                            {"@value":"在文档中划分不同的区域，帮助协作者更好的进行任务分配，文档内划分区域操作内容可以设置为纯文本或富文本。"}
                        ]}
                    ]
                }`,
                sampleJsonImage: `
                                    {
                    body:[
                    {
                    "img": [
                    {"@src": "http://a3.att.hudong.com/57/28/01300000921826141405283668131.jpg"},
                    {"@width": "400px"},
                    {"@height": "150px"}
                    ]
                    },
                    ]
                    }`,
                sampleJsonTable: `
                {
                    body:[
                        {
                            "table":[{"tbody":[
                                    {"tr":[
                                            {"td": [
                                                    {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                ]
                                            },
                                            {"td": [
                                                    {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                ]
                                            },
                                            {"td": [
                                                    {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                ]
                                            },
                                            {"td": [
                                                    {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                ]
                                            },
                                            {"@style":"width:100%;height:20px;border:1px solid #C4C4C4;"}
                                        ]
                                    },
                                    {"tr":[
                                            {"td": [
                                                    {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                ]
                                            },
                                            {"td": [
                                                    {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                ]
                                            },
                                            {"td": [
                                                    {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                ]
                                            },
                                            {"td": [
                                                    {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                ]
                                            },
                                            {"@style":"width:100%;height:20px;border:1px solid #C4C4C4;"}
                                        ]
                                    },
                                    {"tr":[
                                            {"td": [
                                                    {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                ]
                                            },
                                            {"td": [
                                                    {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                ]
                                            },
                                            {"td": [
                                                    {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                ]
                                            },
                                            {"td": [
                                                    {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                ]
                                            },
                                            {"@style":"width:100%;height:20px;border:1px solid #C4C4C4;"}
                                        ]
                                    },
                                ]
                            },
                                {"@cellspacing":"0"},
                                {"@cellpadding":"0"},
                                {"@style":"border-collapse:collapse;border:1px solid #C4C4C4;border-spacing:0"}
                            ]
                        },
                    ]
                        }
                `,
                sampleJsonMix: `
                                    {
                        body:[
                            {
                                "table":[{"tbody":[
                                        {"tr":[
                                                {"td": [
                                                        {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                    ]
                                                },
                                                {"td": [
                                                        {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                    ]
                                                },
                                                {"td": [
                                                        {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                    ]
                                                },
                                                {"td": [
                                                        {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                    ]
                                                },
                                                {"@style":"width:100%;height:20px;border:1px solid #C4C4C4;"}
                                            ]
                                        },
                                        {"tr":[
                                                {"td": [
                                                        {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                    ]
                                                },
                                                {"td": [
                                                        {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                    ]
                                                },
                                                {"td": [
                                                        {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                    ]
                                                },
                                                {"td": [
                                                        {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                    ]
                                                },
                                                {"@style":"width:100%;height:20px;border:1px solid #C4C4C4;"}
                                            ]
                                        },
                                        {"tr":[
                                                {"td": [
                                                        {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                    ]
                                                },
                                                {"td": [
                                                        {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                    ]
                                                },
                                                {"td": [
                                                        {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                    ]
                                                },
                                                {"td": [
                                                        {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                    ]
                                                },
                                                {"@style":"width:100%;height:20px;border:1px solid #C4C4C4;"}
                                            ]
                                        },
                                    ]
                                },
                                    {"@cellspacing":"0"},
                                    {"@cellpadding":"0"},
                                    {"@style":"border-collapse:collapse;border:1px solid #C4C4C4;border-spacing:0"}
                                ]
                            },
                            {
                                "img": [
                                    {"@src": "http://a3.att.hudong.com/57/28/01300000921826141405283668131.jpg"},
                                    {"@width": "400px"},
                                    {"@height": "150px"}
                                ]
                            },
                            {
                                "p":[
                                    {"@style":"text-align:left;font-size:14px"},
                                    {"@value":"在文档中划分不同的区域，帮助协作者更好的进行任务分配，文档内划分区域操作内容可以设置为纯文本或富文本。"}
                                ]
                            }
                        ]
                    }
                `,
            }
        },
        created() {
            // console.log(this.baseUrl,'baseUrl')
        },
        updated() {
        },
        watch: {
            ctctrlTree() {
                // log('tree update')
                this.cleanDocData(this.ctctrlTree)
            }
        },
        methods: {
            actionCreateCtctrl: function () {
                this.dialogFormVisible = false;
                var mode;
                var type = this.selectType;
                var name = this.form.name;
                var displayname = this.form.displayname;
                var color = {};

                // mode
                if (this.form.checkmode && this.form.checkmode.length > 0) {
                    if (this.form.checkmode.length === 1) {
                        if (this.form.checkmode[0] === '只读') {
                            mode = 'noedit';
                        } else if (this.form.checkmode[0] === '不可删除') {
                            mode = 'nodelete';
                        }
                    } else if (this.form.checkmode.length === 2) {
                        mode = 'readonly';
                    } else {
                        mode = 'edit';
                    }
                } else {
                    mode = 'edit';
                };

                // color: "rgb(51, 230, 131)" => {r: 51, g: 230, b: 131}
                if (this.form.color && this.form.color.indexOf("(") === 3) {
                    // console.log("this.form.color", this.form.color)
                    var arr_color = this.form.color.slice(4, -1).split(", ");
                    color.r = Number(arr_color[0]);
                    color.g = Number(arr_color[1]);
                    color.b = Number(arr_color[2]);
                } else {

                }

                // Tag 设置唯一标签，方便之后属性设置
                var o = {
                    // mode: 'edit',
                    mode: mode,
                    name: name, // 唯一标签
                    displayname: displayname,
                };

                // border
                if (this.form.border === '边框') {
                  o.color = color
                } else if (this.form.border === '无') {
                    o.color = {r: 255, g: 255, b: 255}
            }
                // console.log("提交的表单:", type, o)
                this.insertContentControl(type, o);

                // 重置表单
                this.form.displayname = ''
                this.form.name = ''
                this.form.border = '边框'
                this.form.color = 'rgb(155, 155, 155)'
                this.form.checkmode = []
            },
            actionDistPartAuth: function() {
                // log("this.partauthMode:", this.partauthMode)
              //   this.fileName = f;
                var routeData = this.$router.resolve({
                    path: "/partauth",
                    query: {
                        fileName: this.config.document.title,
                        userid: this.config.editorConfig.user.id,
                        name: this.config.editorConfig.user.name,
                        partId: this.currentId,
                        partauthMode: this.partauthMode,
                        // lang: this.selectlang,
                        // leftMenu: this.customization.leftMenu,
                        // rightMenu: this.customization.rightMenu,
                        // statusBar: this.customization.statusBar,
                        // header: this.customization.header,
                        // download: !this.permission.download,
                        // print: !this.permission.print,
                        // copyoutenabled: !this.permission.copyoutenabled,
                    }
                });
                log("routeData:", routeData)
                window.open(routeData.href, "_blank");
            },
            getContentControls: function(type) {
                var name = this.currentTag !== '未命名' ? this.currentTag : '';
                var id = this.currentId || '';
                var expression = {};
                if (type === 'contentControlChildren') {
                    expression = {
                        object:"content",
                        type: "contentControlChildren",
                    };
                    this.docEditor.getDocumentContent(expression);
                    // 处理 从父组件传递过来的 提取到的文档数据
                    setTimeout(() => {
                        console.log("生成tree", this.ctctrlTree)
                        if (this.ctctrlTree) {
                            this.cleanDocData(this.ctctrlTree)
                        }
                    }, 100)
                } else if (type === 'block') {
                    // api get table img all of ContentControl
                    // log("name,  id", name,  id)
                    expression = {
                        object:"content",
                        type: 'all',
                        name: '',
                        id: id,
                    }
                    this.docEditor.getDocumentContent(expression);
                    setTimeout(() => {
                        log("提取内容：", this.ctctrlContentAll)
                        if (this.ctctrlContentAll) {
                            this.form4.content = this.ctctrlContentAll['content'] || ''
                        }
                    }, 100)
                } else if (type === 'inline') {
                    expression = {
                        object: 'content', //操作内容域，必填项
                        type: 'text', //提取类型为文本，必填项
                        name: '', //内容域的标签，可以是英文及数字
                        id: id, //内容域的id，name及id可选一项填写，name优先级高于id，有name时则id无效 name，id的关键字都设置上，同时都不设置值则提取当前文档所有内容域的文本，返回值包含内容域的name,id及对应的文本内容
                    }
                    this.docEditor.getDocumentContent(expression);
                    setTimeout(() => {
                        log("提取内容：", this.ctctrlContentAll)
                        if (this.ctctrlContentAll) {
                            this.form4.content = this.ctctrlContentAll['text'][0]['text'] || ''
                        }
                    }, 100)
                }
            },
            cleanDocData: function (data) {
                // 先清空原来的列表
                this.ctctrlChildren = [];
                var object = data.object;
              var type = data.type;
                if (object === 'content' && type) {
                    if (type === 'contentControlChildren') {
                        var c = data.contentcontrols;
                        // this.ctctrlChildren.push(c)
                        for (var i = 0; i < c.length; i++) {
                            var e = c[i];
                            if (!e.Alias) {
                                e.Alias = '未命名'
                            }
                            if (!e.Tag) {
                                e.Tag = '未命名'
                          }

                            this.ctctrlChildren.push(e);
                        }
                        // console.log("ctctrlChildren===", this.ctctrlChildren)
                    } else if (type === 'property') {
                        // console.log("property", data)
                    }
                }
            },
            onEnterCtcrlItem: function(i) {
                this.currentHover = i
            },
            onLeaveCtcrlItem: function(i) {
                this.currentHover = -1
            },
          onClickCtctrlItem: function (i, tag, id, alias, type) {
            
                this.currentClick = i;
                this.currentHover = -1;
                this.currentId = id;
                this.currentTag = tag;
                this.currentAlias = alias;
                this.currentType = type;
                // console.log("clicked tag id: ", tag, id)
                // 选择指定内容域并跳转到内容域所在位置
                var expression = {
                    object: "content",          // 表示是文档控制域，必填项
                    type: "select",             // 表示是选中操作，必填项
                    // name: tag,               // 内容域的标签，优先级大于id
                    id: id,                     // 内容域的id
                }
                this.docEditor.setDocumentContent(expression);
            },
          openCtctrlPanel: function (command) {
            if (command === 'simpletext' || command === 'richtext') {
                    this.selectType = command;
                    this.dialogFormVisible = true;
                    var fenpei = (new Date).getTime().toString();
                    this.form.name = fenpei;
                } else if (command === 'insertContent') {
                    if (this.currentType === 'block') {
                        this.dialogFormVisible2 = true;
                    } else if (this.currentType === 'inline') {
                        this.dialogFormVisible3 = true;
                    }
                } else if (command === 'extractContent') {
                    this.dialogFormVisible4 = true;
                    var type = this.currentType;
                    this.getContentControls(type);
                }
            },
          //ceshi: function () {
          //  this.docEditor.destroyEditor();
          //},
            // 新增内容域 & 设置内容域属性
            insertContentControl: function (type, props) {
                if (type) {
                    // 在文字处理当前光标所在位置创建文档控制域
                    var expression1 = {
                        object: "content", //表示是文档控制域，必填项
                        type: "create", //表示是建立操作，目前只支持建立，必填项
                        ctrltype: type, //文档控制域的类型，必填项，目前支持两种类型simpletext为纯文本类型，richtext是富文本类型，纯文本类型不支持嵌入
                        props: {
                            mode: props.mode, //文档控制域的属性设置，可选项
                            name: props.name, //内容域的标签，可以是英文数字,与id互斥，优先级高于id
                            displayname: props.displayname, //在编辑区显示的名字
                        }
                  }
                  
                    this.docEditor.setDocumentContent(expression1);
                }

                // 设置内容域的编辑/只读/隐藏等属性，参数是JSON格式的字符串对象
                var expression2 = {
                    object: "content", //表示操作对象为内容域，必填项
                    type: "property", //表示操作行为是属性设置，必填项
                    list: [{ //可一次性进行传递，优化效率
                        name: props.name === '未命名' ? '' : props.name,  //内容域的标签，可以是英文数字,与id互斥，优先级高于id
                        id: props.id,  //内容域的id,时间戳，纯数字，与name互斥，优先级低于name
                        color: props.color, //内容域边框颜色，值为r,g,b对应的值
                        mode: props.mode, //值是edit（设为可编辑,如果原来是可删除则为可删除，否则是不可删除可编辑）、readonly（设为只读，不可删除同时不可编辑）hide（设为隐藏）nodelete(不可删除内容域)noedit（不可编辑内容域）中的一个，必填项
                        // hideIcon:{ //内容域隐藏时，绘制隐藏区域的图标配置
                        //     "url":"", //字符串类型，图标地址（需要http地址，必填项）
                        //     "mode":"tile",//字符串类型，图标绘制方式：tile：平铺，stretch：拉伸，center：居中。不加此参数的默认绘制方式为内容域区域左上位置绘制
                        //     "width":32,//数字类型，绘制图标单元的宽度，不加此参数默认为内容域区域宽度
                        //     "height":32,//数字类型，绘制图标单元的高度，不加此参数默认为内容域区域高度
                        //     "type":"png"//字符串类型，绘制图标的文件类型
                        // }
                    }]
                }
                log("提交 props===", expression2)
                if (props.name_new) {
                    expression2.list[0].replaceTagName = props.name_new;
                }
                this.docEditor.setDocumentContent(expression2);
            },
            setCtctrlProp: function (cc) {
                this.form.name = cc.Tag;
                this.dialogFormVisible = true;
            },
            setCtctrlContent: function () {
                // var _id = this.setContentId;
                var _id = this.currentId;
                var _name = this.currentTag;
                var _type = this.currentType;
                var type = this.activeName;
                var expression;
                var jsonStr;
                // log("type", type)
                if (_type === 'inline') {
                    this.dialogFormVisible3 = false;
                    // 在文字处理中设置内容域的文字内容，内容域的内容会全部被清除，会按照第一个文字的格式进行格式设置
                    jsonStr = this.textarea5
                    expression = {
                        object: "content",      // 表示操作对象为内容域，必填项
                        type: "replace",        // 表示操作行为是替换内容，必填项
                        name: '',               // 内容域的标签，可以是英文数字，优先级高于ID
                        id: _id,                // 内容域的ID，name和id必须有一
                        value: jsonStr         // 替换完成后内容域内的文字内容
                    };
                } else if (_type === 'block') {
                    this.dialogFormVisible2 = false;
                    if (type ==='simpletext') {
                        jsonStr = this.textarea1 ? this.textarea1 :
                            {
                                body:[
                                    {
                                        "p":[
                                            {"@style":"text-align:left;font-size:14px"},
                                            {"@value":"在文档中划分不同的区域，帮助协作者更好的进行任务分配，文档内划分区域操作内容可以设置为纯文本或富文本。"}
                                        ]
                                    },
                                ]
                            }
                    }
                    if (type === 'image') {
                        /*
                           必须以body 开头，目前支持table span p img标签,必填项，json对象（拟html）
                           样式写在style中，目前只支持 border,font-family,color,width,height,font-style,font-weight,font-size,text-align,
                           表格table支持rowspan,colspan,并且td支持valign属性操作
                        */

                        jsonStr = this.textarea2 ? this.textarea2 :
                            {
                                body:[
                                    {
                                        "img": [
                                            {"@src": `${this.baseUrl}samples/sample.png`},
                                            {"@width": "427px"},
                                            {"@height": "284px"}
                                        ]
                                    },
                                ]
                            }
                    }
                    if (type === 'table') {
                        jsonStr = this.textarea3 ? this.textarea3 :
                            {
                                body:[
                                    {
                                        "table":[{"tbody":[
                                                {"tr":[
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"@style":"width:100%;height:20px;border:1px solid #C4C4C4;"}
                                                    ]
                                                },
                                                {"tr":[
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"@style":"width:100%;height:20px;border:1px solid #C4C4C4;"}
                                                    ]
                                                },
                                                {"tr":[
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"@style":"width:100%;height:20px;border:1px solid #C4C4C4;"}
                                                    ]
                                                },
                                                // {"tr":[
                                                //         {"td": [
                                                //                 {"@style":"width:50%;border:1px solid black;"},
                                                //                 {"@value":"44444"}
                                                //             ]
                                                //         },
                                                //         {
                                                //             "td": [
                                                //                 {"@style":"width:50%;border:1px solid black;"},
                                                //                 {"@value":"55555"}
                                                //             ]
                                                //         },
                                                //         {"@style":"width:100%;height:20px;border:1px solid black;"}
                                                //     ]
                                                // }
                                            ]
                                        },
                                            {"@cellspacing":"0"},
                                            {"@cellpadding":"0"},
                                            {"@style":"border-collapse:collapse;border:1px solid #C4C4C4;border-spacing:0"}
                                        ]
                                    },
                                ]
                            }
                    }
                    if (type === 'complex') {
                        jsonStr = this.textarea4 ? this.textarea4 :
                            {
                                body:[
                                    {
                                        "table":[{"tbody":[
                                                {"tr":[
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"@style":"width:100%;height:20px;border:1px solid #C4C4C4;"}
                                                    ]
                                                },
                                                {"tr":[
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"@style":"width:100%;height:20px;border:1px solid #C4C4C4;"}
                                                    ]
                                                },
                                                {"tr":[
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"td": [
                                                                {"@style":"width:60px;border:1px solid #C4C4C4;"},
                                                            ]
                                                        },
                                                        {"@style":"width:100%;height:20px;border:1px solid #C4C4C4;"}
                                                    ]
                                                },
                                                // {"tr":[
                                                //         {"td": [
                                                //                 {"@style":"width:50%;border:1px solid black;"},
                                                //                 {"@value":"44444"}
                                                //             ]
                                                //         },
                                                //         {
                                                //             "td": [
                                                //                 {"@style":"width:50%;border:1px solid black;"},
                                                //                 {"@value":"55555"}
                                                //             ]
                                                //         },
                                                //         {"@style":"width:100%;height:20px;border:1px solid black;"}
                                                //     ]
                                                // }
                                            ]
                                        },
                                            {"@cellspacing":"0"},
                                            {"@cellpadding":"0"},
                                            {"@style":"border-collapse:collapse;border:1px solid #C4C4C4;border-spacing:0"}
                                        ]
                                    },
                                    {
                                        "img": [
                                            {"@src": `${this.baseUrl}samples/sample.png`},
                                            {"@width": "400px"},
                                            {"@height": "150px"}
                                        ]
                                    },
                                    {
                                        "p":[
                                            {"@style":"text-align:left;font-size:14px"},
                                            {"@value":"在文档中划分不同的区域，帮助协作者更好的进行任务分配，文档内划分区域操作内容可以设置为纯文本或富文本。"}
                                        ]
                                    }
                                ]
                            }
                    }
                    expression = {
                        object: "content",      //表示是文档控制域，必填项
                        type: "html",           //表示添加内容为html
                        name: '',               //内容域的标签
                        id: _id,                //内容域的id
                        jsonStr: jsonStr,            //必填项,添加到内容域的json对象或字符串,格式模拟html，详见样例
                        bClear: false,          //是否清空指定内容域的内容，默认为false不清除.
                    }
                }
                log("expression:", expression)
                this.docEditor.setDocumentContent(expression);

            },
            resetCtctrlContent: function () {
                // log("color changed!")

                // mode
                var mode;
                if (this.reset.checkmode && this.reset.checkmode.length > 0) {
                    if (this.reset.checkmode.length === 1) {
                        if (this.reset.checkmode[0] === '只读') {
                            mode = 'noedit';
                        } else if (this.reset.checkmode[0] === '不可删除') {
                            mode = 'nodelete';
                        }
                    } else if (this.reset.checkmode.length === 2) {
                        mode = 'readonly';
                    } else {
                        mode = 'edit';
                    }
                } else {
                    mode = 'edit';
                };

                // var type = this.selectType;
                var name = this.currentTag;
                // var name_new = this.reset.name;
                // var displayname = this.reset.displayname;
                var id = this.currentId;
                var color = {};

                // color: "rgb(51, 230, 131)" => {r: 51, g: 230, b: 131}
                if (this.reset.color && this.reset.color.indexOf("(") === 3) {
                    // console.log("this.form.color", this.form.color)
                    var arr_color = this.reset.color.slice(4, -1).split(", ");
                    color.r = Number(arr_color[0]);
                    color.g = Number(arr_color[1]);
                    color.b = Number(arr_color[2]);
                } else {

                }

                // Tag 设置唯一标签，方便之后属性设置
                var o = {
                    // mode: 'edit',
                    mode: mode,
                    name: name,
                    id: id,
                    // name_new: name_new,
                };

                if (this.reset.border === '边框') {
                    o.color = color
                } else if (this.reset.border === '无') {
                    o.color = {r: 255, g: 255, b: 255}  // 无法确定无边框的颜色 先不设置这个选项
                }
                
                // log("o:", o)

                this.insertContentControl(null, o);

                // 重置表单内容
                // this.reset.displayname = ''
                // this.reset.name = ''
                // this.reset.border = '边框'
                // this.reset.color = 'rgb(220, 220, 220)'
                // this.reset.checkmode = []
            },
            // openCirclePanel: function (command) {
            //     if (command === 'insertMenu') {
            //         this.dialogFormVisible2 = true;
            //     } else if (command === 'resetMenu') {
            //         this.reset.displayname = this.currentAlias;
            //         this.reset.name = this.currentTag;
            //         this.dialogFormVisible3 = true;
            //     } else if (command === 'clearMenu') {
            //         this.clearCtctrlContent(this.currentId);
            //     }
                // var id = this.setContentId;
                // this.setContentId = id;
                // this.dialogFormVisible2 = true;
            // },
            handleClick: function (tab, event) {
                this.dealWithOk()
            },
            getCtctrlContents: function () {
            },
            clearCtctrlContent: function (id) {
                var expression;
                // 清除指定内容域内容（仅限富文本内容域）
                expression = {
                    object: "content",  //表示是文档控制域，必填项
                    type: "clear",      //表示是清除内容域内容，必填项
                    name: '',          //内容域的标签
                    id: id,            //内容域的id
                }
                this.docEditor.setDocumentContent(expression);
            },
            // setReJson:function(){
            //     var expression = {
            //         object: 'content',
            //         type:'jsonReplace',
            //     }
            //     // this.textarea2="{\"body\":[{\"p\":[{\"@style\":\"border:none\"},{\"order\":0},{\"span\":[{\"order\":0},{\"@value\":\"回填数据修改11\",\"@style\":\"font-size:0.91em;color:#000000\"}]}]}]}"
            //     console.log(JSON.parse(this.textarea7),'textarea7')
            //     expression.json = JSON.parse(this.textarea7);
            //     console.log(expression,'exp')
            //     this.docEditor.setDocumentContent(expression);
            //     this.dialogFormVisible7 = false;
            // },
            dealWithOk: function () {
                // log('enter +++')
                let res = true
                let obj = {
                    'simpletext': this.textarea1,
                    'image': this.textarea2,
                    'table': this.textarea3,
                    'complex': this.textarea4,
                }
                let type = this.activeName
                obj[type] ? res = false : res = true
                this.noOk = res
            }
        },
    }
</script>

<style scoped>
    .block {
        display: block;
    }
    .wrap {
        padding: 0 15px;
    }
    .top-area {
        /*height: 25px;*/
        padding-bottom: 15px;
        border-bottom: 1px solid #DBDBDB;;
    }
    .title {
        font-size: 14px;
        line-height: 26px;
    }
    .top-button {
        background: #FFFFFF;
        border: 1px solid #CCCCCC;
        border-radius: 2px;
        height: 24px;
        width: 56px;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        text-align: center;
        cursor: pointer;
    }
    .bottom-button-container {
        /*width: 132px;*/
    }
    .bottom-button {
        margin-left: 100px;
    }
    .bottom-setting {
        padding-top: 35px;
        border-bottom: 1px solid #DBDBDB;
        padding-bottom: 25px;
    }
    .bottom-coauther {
        padding-top: 25px;
    }
    .bottom-item {
        margin-bottom: 20px;
    }
    .bottom-title {
        font-weight: bold;
        font-size: 12px;
        margin-bottom: 10px;
    }
    .bottom-label {
        line-height: 30px;
    }
    .bottom-select {
        width: 80px;
    }
    .bottom-radio {
        margin-right: 5px !important;
    }
    .flex {
        display: flex;
        justify-content: space-around;
    }
    .flex-start {
        display: flex;
        justify-content: flex-start;
    }
  .tree-container {
    /*height: 50%;*/
    height: 230px;
    padding: 15px 0;
    margin-bottom: 20px;
    border-bottom: 1px solid #DBDBDB;
  }
    .overflow {
        height: 100%;
        overflow-y: auto;
    }
    .activeHover {
        /*background: #E5E5E5;*/
        background: #E1E1E1;
    }
    .activeClick {
        background: #E1E1E1;
        color: #4DA6FF;
    }
    .node-text {
        display: inline-block;
        font-size: 12px;
        line-height: 29px;
        max-width: 230px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .el-dropdown-link {
        cursor: pointer;
        /*color: #409EFF;*/
    }
    .el-icon-arrow-down {
        font-size: 12px;
    }
    .ctctrl-node {
        width: 100%;
        height: 28px;
        cursor: pointer;
        /*max-width: 238px;*/
        /*white-space: nowrap;*/
        /*overflow: hidden;*/
        /*text-overflow: ellipsis;*/
    }
    .tishi-text {
        color: red;
        margin-bottom: 10px;
    }
    .dialog-title {
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
    }
    .form-item-title {
        font-weight: bold !important;
        font-size: 12px !important;
    }
    .form-inline {
        display: inline-block;
    }
    .form-margin-adjust {
        margin-bottom: 0 !important;
    }
    .form-item-checkbox {
        margin-right: 0 !important;
        display: block !important;
        width: 85px !important;
        font-size: 12px !important;
    }
    .dialog4-title {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
    }
    .extract-area {
        width: 547px;
        height: 182px;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;
        box-sizing: border-box;
        border-radius: 4px;
        margin: 0 auto;
        overflow-y: auto;
    }
    .dialog-alert {
        width: 547px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 10px;
    }
    .extract-text {
        font-size: 14px;
        padding: 11px 10px;
    }
    .insert-text {
        font-size: 14px;
        padding: 10px 0;
    }
    .insert-sample {
        font-size: 14px;
        padding-bottom: 10px;
        color: #BDBDBD;
        max-height: 125px;
        overflow-y: auto;
    }
    .dialog-button {
        width: 100px;
    }


    /deep/ .el-tabs__item {
        font-size: 16px;
    }
    /deep/ .el-alert--info.is-light {
        background-color: #FFF8EB;
        border: 1px solid #FFD98D;
    }
</style>



// WEBPACK FOOTER //
// src/components/wordbar.vue